import React from 'react'

const Plate = props => (
    <svg viewBox="0 0 200 200" {...props}>
        <path d="M100 1C45.3 1 1 45.3 1 100s44.3 99 99 99 99-44.3 99-99-44.3-99-99-99zm72.6 64.7l-23 9.2c-5.4-10.6-14-19.2-24.5-24.5l9.2-23c16.8 7.9 30.4 21.5 38.3 38.3zm-99.3 18c2.3-4.4 6-8.1 10.4-10.4 29.2-15.3 58.4 13.9 43.1 43.1-2.3 4.4-6 8.1-10.4 10.4-29.2 15.3-58.5-14-43.1-43.1zm-45.9 50.6l23-9.2c5.4 10.6 14 19.2 24.5 24.5l-9.2 23c-16.8-7.9-30.4-21.5-38.3-38.3z" />
    </svg>
)

export default Plate